import React from 'react'
import VitalSummary from './vital-summary'
import SleepChart from './sleep-chart'
import RespiratoryRateChart from './respiratory-rate-chart'
import BloodOxygenChart from './blood-oxygen-chart'
import BloodPressureChart from './blood-pressure-chart'
import HeartRateChart from './heart-rate-chart'
import TemperatureChart from './temperature-chart';
import WeightChart from './weight-chart';

import { Button } from '@mui/material'
import { BotMessageSquare } from 'lucide-react'
import * as aiAPI from '../../../HTTPS/AIChatApi'
import { AIFormattedSummary } from './formatAISummary'
import { usePatient } from '../../../context/PatientContext';

export const OverallSummaryCard = ({ vitalSummary,
  sleepData,
  respiratoryRateData,
  heartrateData,
  bloodOxygenData,
  bloodPressureData,
  temperatureData,
  weightData,
  onCardClick,
  selDate }) => {

  const {
    patient,
    patientList,
    setPatient,
    setPatientList,
  } = usePatient();

  const [selectCard, setSelectCard] = React.useState({
    label: 'Sleep',
  });

  const [summary, setSummary] = React.useState(null)
  const [loading, setLoading] = React.useState(false)
  const [summaryType, setSummaryType] = React.useState('brief')
  const [daysBack, setDaysBack] = React.useState(7)

  const handleSummarize = React.useCallback(async (type = summaryType, days = daysBack) => {
    setLoading(true)
    try {
      const req = { 
        "user_id": patient?.providerUserId, 
        // "user_id": 'To test with fixed user',
        "summary_type": type, 
        "current_date": selDate.format("YYYY-MM-DD"),
        "days_back": days
      }
      const data = await aiAPI.fetcgAISummaryEndpoint(req);

      setSummary(data.data.summary || "No summary returned.")
    } catch (err) {
      console.error(err)
      setSummary("Failed to fetch summary. Please try again.")
    } finally {
      setLoading(false)
    }
  }, [summaryType, daysBack, selDate])

  const handleTypeChange = (newType) => {
    setSummaryType(newType)
    handleSummarize(newType, daysBack)
  }

  const handleDaysChange = (newDays) => {
    setDaysBack(newDays)
    handleSummarize(summaryType, newDays)
  }

  // Reset summary when date changes
  React.useEffect(() => {
    setSummary(null)
  }, [selDate]);

  return (
    <div className="mt-6 space-y-6">
      {/* AI Summary */}
      {/*{(patient?.id === 1 || patient?.id === 5045 || patient?.id === 6045) && (*/}
        <>
          {loading && <AIFormattedSummary loading={true} />}
          {!loading && summary && (
            <AIFormattedSummary 
              rawText={summary} 
              summaryType={summaryType}
              daysBack={daysBack}
              onTypeChange={handleTypeChange}
              onDaysChange={handleDaysChange}
              loading={loading}
            />
          )}
          {!loading && !summary && (
            <div className="flex justify-end mb-4">
              <Button
                variant="contained"
                onClick={() => handleSummarize()}
                startIcon={<BotMessageSquare className="text-white" size={18} />}
              >
                Summarize with AI
              </Button>
            </div>
          )}
        </>
      {/*)} */}

      {/* Two-Column Layout */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Vitals Snapshot */}
        <VitalSummary
          data={vitalSummary}
          onCardClick={(item, index) => {
            setSelectCard(item);
            onCardClick?.(item, index);
          }} />

        {/* Sleep Chart */}
        {selectCard.label === 'Sleep' && <SleepChart sleepData={sleepData} chartTitle={'Sleep Chart'} />}
        {selectCard.label === 'Breathing Rate' && <RespiratoryRateChart respiratoryRateData={respiratoryRateData} />}
        {selectCard.label === 'Heart Rate' && <HeartRateChart heartrateData={heartrateData} />}
        {selectCard.label === 'SO₂ Level' && <BloodOxygenChart bloodOxygenData={bloodOxygenData} />}
        {selectCard.label === 'Blood Pressure' && <BloodPressureChart bloodPressureData={bloodPressureData} />}
        {selectCard.label === 'Temperature' && <TemperatureChart temperatureData={temperatureData} />}
        {selectCard.label === 'Weight' && <WeightChart weightData={weightData} />}
      </div>
    </div>
  )
}
